import { render, staticRenderFns } from "./AppAvaliacao.vue?vue&type=template&id=a3ac8ae0&"
import script from "./AppAvaliacao.vue?vue&type=script&lang=js&"
export * from "./AppAvaliacao.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports